module.exports = __webpack_public_path__ + "img/map.1cd670d6.png";